import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import galleryItems from '@/assets/json/gallery-items.json'

export const useSlideshowStore = defineStore('gallery/slideshow', () => {
  const _dataItems = galleryItems.map((e, i) => ({ ...e, actived: i == 0 ? true : false }))

  // State -----------------------------------------
  const items = ref(_dataItems)

  // Getters ---------------------------------------
  const activedItem = computed(() => items.value.find((e) => e.actived == true))

  // Actions ---------------------------------------
  function $reset() {
    items.value = _dataItems
  }

  function setActivedItem(id) {
    if (items.value.find((e) => e.id == id)) {
      items.value.forEach((e) => {
        e.actived = e.id === id
      })
      return true
    }
    return false
  }

  function setActivedItemNext() {
    if (activedItem.value !== undefined) {
      const targetItem = items.value.find((e) => e.id == activedItem.value.id + 1)
      if (targetItem) {
        setActivedItem(targetItem.id)
        return
      }
    }
    setActivedItem(1)
  }

  function clearActivedItem() {
    items.value.forEach((e) => {
      e.actived = false
    })
  }

  // Main Setup ------------------------------------
  window.actived = setActivedItem

  // -----------------------------------------------
  return { activedItem, items, $reset, setActivedItem, setActivedItemNext, clearActivedItem }
})
